<template>
<div class="site container hfeed inner-page">
  <HeadNav selectedLanguage="en" page="features" />
  <div class="site-content page-primary">
    <article class="article-shell page-main-narrow">
      <Breadcrumbs :items="crumbs" />
      <h1>GB WhatsApp Features - Privacy, Customization &amp; More</h1>
      <p class="lede">
        GB WhatsApp is popular mainly because it adds more customization and privacy controls to the familiar WhatsApp experience. The exact options can vary between versions, but the features below are commonly found in recent GB WhatsApp builds.
      </p>
      <p>
        If you are already looking for the latest APK, visit the
        <router-link to="/download/"><strong>GB WhatsApp Download</strong></router-link>
        page.
      </p>

      <h2>Privacy Features</h2>
      <p>Privacy controls are one of the main reasons users choose GB WhatsApp. Depending on the version, you may have more control over what other people can see when you use WhatsApp.</p>
      <p>Common options include hiding your <strong>online status, blue ticks, typing indicator, and recording status</strong>. Some builds also include <strong>Freeze Last Seen</strong>, which lets you keep your last-seen time from changing.</p>
      <p>These settings can be useful when you want to read or reply to messages without showing every activity signal to your contacts.</p>
      <img class="feature-image" src="@/assets/content/ghost-mode-setting.webp" alt="GB WhatsApp ghost mode setting" loading="lazy" decoding="async">

      <h2>Anti-Delete Messages &amp; Status</h2>
      <p>Some GB WhatsApp versions include options that let you view messages or status updates even after the sender deletes them.</p>
      <p>For example, an Anti-Delete Messages option may keep a deleted message visible in your chat. Similar controls may also let you view status updates that have been removed.</p>
      <p>Availability can vary between versions, so check your installed build before looking for a specific option.</p>

      <h2>Themes &amp; Customization</h2>
      <p>If the standard WhatsApp interface feels too limited, GB WhatsApp offers much more room for customization.</p>
      <p>Depending on the build, you can change <strong>themes, fonts, chat colors, wallpapers, message bubbles, ticks, and even the app icon</strong>. Some versions also provide a collection of downloadable themes that can be applied without changing the rest of the app.</p>
      <p>This is one of the biggest visual differences between GB WhatsApp and the official WhatsApp app.</p>
      <img class="feature-image" src="@/assets/content/themes-4k.webp" alt="GB WhatsApp themes screen" loading="lazy" decoding="async">

      <h2>Messaging &amp; Auto Reply</h2>
      <p>GB WhatsApp may include additional messaging tools that are not available in the standard app.</p>
      <p>Popular options include <strong>Auto Reply, scheduled messages, and additional controls for individual chats or groups</strong>. Auto Reply can be particularly useful when you want to send a predefined response while you are unavailable.</p>
      <p>The available tools depend on the version you install.</p>

      <h2>Large File &amp; Media Sharing</h2>
      <p>Some GB WhatsApp builds advertise higher limits for sending videos, documents, images, and other files.</p>
      <p>You may also find additional controls for <strong>image quality, video quality, compression, and media sharing</strong>. These options can be useful when you want more control over how your photos and videos are sent.</p>
      <p>Actual limits can change between versions, so check the APK information for the build you are using.</p>

      <h2>DND &amp; App Lock</h2>
      <p>GB WhatsApp can also provide extra controls for reducing interruptions or protecting private conversations.</p>
      <p>A <strong>DND mode</strong> may help you temporarily reduce WhatsApp notifications or activity, while <strong>App Lock</strong> can add a PIN, password, pattern, or biometric lock to the app, depending on the version.</p>
      <p>These features are especially useful if you share your phone with other people or simply want more control over when WhatsApp gets your attention.</p>
      <img class="feature-image" src="@/assets/content/DND.webp" alt="GB WhatsApp DND feature" loading="lazy" decoding="async">

      <h2>Dual WhatsApp Accounts</h2>
      <p>Want to keep two WhatsApp accounts on one phone? GB WhatsApp can be used alongside another supported WhatsApp installation in some setups.</p>
      <p>Whether this works depends on the package version and your Android device. If you use two accounts, make sure each phone number is verified with the correct installation.</p>

      <h2>Other Useful Features</h2>
      <p>GB WhatsApp builds can include many smaller options in addition to the major features above. These may include:</p>
      <ul>
        <li><strong>Hide View Status</strong> - View statuses without showing that you have seen them.</li>
        <li><strong>Call Privacy</strong> - Additional controls for incoming WhatsApp calls.</li>
        <li><strong>Chat Lock</strong> - Protect selected conversations with an additional lock.</li>
        <li><strong>Custom Notifications</strong> - Use different notification settings for chats or contacts.</li>
        <li><strong>Message Scheduling</strong> - Prepare messages to be sent at a chosen time.</li>
        <li><strong>More Emoji &amp; Fonts</strong> - Access additional visual customization options.</li>
      </ul>
      <p>Not every feature is available in every release, so the settings on your device are the best way to confirm what your current version supports.</p>

      <h2>GB WhatsApp Features vs Official WhatsApp</h2>
      <p>The biggest difference is flexibility. Official WhatsApp focuses on a consistent, supported experience, while GB WhatsApp adds more customization and additional controls.</p>
      <p>If you are mainly interested in themes, privacy options, or extra messaging tools, GB WhatsApp may offer more choices. If official support, predictable updates, and account stability matter more to you, the standard WhatsApp app is the safer choice.</p>
      <p>See our <router-link to="/comparison/"><strong>GB WhatsApp vs Official WhatsApp comparison</strong></router-link> to compare the two apps in more detail.</p>

      <h2>Before You Download</h2>
      <p>GB WhatsApp is a third-party modified app, so some features may change, disappear, or work differently after an update. Check the version information before installing and back up important chats if you are switching from another WhatsApp client.</p>
      <p>Ready to try it? Go to the <router-link to="/download/"><strong>GB WhatsApp APK Download</strong></router-link> page to check the current version.</p>
    </article>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/page-narrow-layout.scss';
import HeadNav from '@/components/HeadNav.vue';
import Breadcrumbs from '@/components/Breadcrumbs.vue';

export default {
  name: 'Features',
  components: { HeadNav, Breadcrumbs },
  data() {
    return {
      crumbs: [
        { label: 'Home', to: '/' },
        { label: 'Features', to: '' },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.inner-page .article-shell {
  width: 85%;
  margin: 0 auto;
  padding: 1rem 1.25rem 3.5rem;
  line-height: 1.7;
  font-size: 1.05rem;
  color: #222;
}
h1 {
  color: #128c7e;
  font-size: 2rem;
  line-height: 1.2;
}
h2 {
  color: #075e54;
  font-size: 1.35rem;
  margin-top: 2rem;
}
.lede {
  background: #f4fbf8;
  border-left: 4px solid #25d366;
  padding: 1rem 1.2rem;
  border-radius: 0 8px 8px 0;
}
.feature-image {
  display: block;
  width: min(420px, 100%);
  margin: 1rem auto 1.5rem;
  border-radius: 8px;
  border: 1px solid #e4eee9;
}
ul {
  padding-left: 1.35rem;
}
li {
  margin: 0.35rem 0;
}
a {
  color: #128c7e;
  font-weight: 600;
}
</style>
